<route lang="yaml">
meta:
  title: 主页
  icon: ant-design:home-twotone
</route>

<script setup lang="ts">
import { ElMessage } from 'element-plus'
import { onMounted, ref } from 'vue'
import authApi from '@/api/modules/auth'
import WecomBindDialog from '@/components/WecomBindDialog.vue'

const wecomBindDialogRef = ref()
const wecomBindStatus = ref({
  is_bound: undefined,
  wecom_info: null as any,
})

// 获取企业微信绑定状态
async function fetchWecomBindStatus() {
  try {
    const res = await authApi.getWecomBindStatus()
    wecomBindStatus.value = res.data || { is_bound: false, wecom_info: null }
  }
  catch (error: any) {
    ElMessage.error(error.message || '获取绑定状态失败')
  }
}

// 打开绑定弹窗
function handleBind() {
  wecomBindDialogRef.value?.open()
}

// 绑定成功回调
function handleBindSuccess() {
  ElMessage.success('企业微信绑定成功')
  fetchWecomBindStatus()
}

// 解绑企业微信
async function handleUnbind() {
  try {
    await authApi.unbindWecom()
    ElMessage.success('解绑成功')
    fetchWecomBindStatus()
  }
  catch (error: any) {
    ElMessage.error(error.message || '解绑失败')
  }
}

onMounted(() => {
  fetchWecomBindStatus()
})
</script>

<template>
  <div class="m-0 flex-1">
    <FaPageMain class="m-0 flex-1" title-class="flex flex-wrap items-center justify-between gap-4">
      <div style="width: 100%;">
        <!-- 企业微信绑定状态 -->
        <ElRow v-if="wecomBindStatus.is_bound !== undefined && !wecomBindStatus.is_bound" :gutter="16" style="margin-top: 20px;">
          <ElCol :span="24">
            <ElCard shadow="hover">
              <div class="wecom-bind-section">
                <div class="wecom-bind-header">
                  <FaIcon name="i-ri:wechat-line" style="font-size: 24px; color: #07c160;" />
                  <span style="margin-left: 8px; font-size: 16px; font-weight: bold;">企业微信绑定</span>
                </div>
                <div v-if="wecomBindStatus.is_bound" class="wecom-bind-info">
                  <div class="wecom-user-info">
                    <img v-if="wecomBindStatus.wecom_info?.avatar" :src="wecomBindStatus.wecom_info.avatar" class="wecom-avatar">
                    <div class="wecom-details">
                      <div class="wecom-name">
                        {{ wecomBindStatus.wecom_info?.name }}
                      </div>
                      <div class="wecom-bind-time">
                        绑定时间：{{ wecomBindStatus.wecom_info?.bind_time }}
                      </div>
                    </div>
                  </div>
                  <ElButton type="danger" @click="handleUnbind">
                    解除绑定
                  </ElButton>
                </div>
                <div v-else class="wecom-bind-info">
                  <div class="wecom-unbind-tip">
                    您还未绑定企业微信，绑定后可以使用企业微信登录
                  </div>
                  <ElButton type="primary" @click="handleBind">
                    绑定企业微信
                  </ElButton>
                </div>
              </div>
            </ElCard>
          </ElCol>
        </ElRow>
      </div>
    </FaPageMain>

    <!-- 绑定弹窗 -->
    <WecomBindDialog ref="wecomBindDialogRef" @success="handleBindSuccess" />
  </div>
</template>

<style scoped>
.wecom-bind-section {
  padding: 20px;
}

.wecom-bind-header {
  display: flex;
  align-items: center;
  padding-bottom: 15px;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.wecom-bind-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wecom-user-info {
  display: flex;
  gap: 15px;
  align-items: center;
}

.wecom-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.wecom-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.wecom-name {
  font-size: 16px;
  font-weight: bold;
}

.wecom-bind-time {
  font-size: 14px;
  color: #999;
}

.wecom-unbind-tip {
  font-size: 14px;
  color: #666;
}
</style>
